module.exports = __webpack_public_path__ + "img/frame-4.c83ae294.png";